import { BrowserLocaleDateFormatter, BrowserLocaleTimeFormatter } from 'prace-common-components'
import { EditFlowCutOff } from 'components/EditTimeFrames/types'

const time = (date: string) => new Date(date).getTime()
const formatDate = (date: string) =>
  `${BrowserLocaleDateFormatter.format(new Date(date))} ${BrowserLocaleTimeFormatter.format(new Date(date))}`

/* One message per problem, naming the cut-off, step and field so the admin knows exactly what to fix */
export const cutoffErrors = (cutoffs: EditFlowCutOff[], withTimeframes: boolean) => {
  const errors: string[] = []
  cutoffs.forEach((cutoff, idx) => {
    const name = cutoff.title ? `Cut-off "${cutoff.title}"` : `Cut-off ${(cutoff.order ?? idx) + 1}`
    const previous = cutoffs[idx - 1]

    if(!cutoff.title) errors.push(`${name}: name is required`)
    else if(cutoffs.some((other) => other !== cutoff && other.title === cutoff.title))
      errors.push(`${name}: name is used by more than one cut-off`)

    if(!cutoff.start) {
      errors.push(`${name}: opening date is required`)
      return
    }
    if(previous?.start && time(cutoff.start) < time(previous.start)) {
      const previousName = previous.title ? `cut-off "${previous.title}"` : 'the previous cut-off'
      errors.push(`${name}: opening date (${formatDate(cutoff.start)}) cannot be before the opening date of ` +
        `${previousName} (${formatDate(previous.start)})`)
    }

    if(!withTimeframes) return
    cutoff.timeframes?.forEach(({ start, end, stepOrder, stepTitle }) => {
      const step = `${name}, step "${stepTitle}"`
      if(!start) errors.push(`${step}: opening date is required`)
      else if(!stepOrder && !end) errors.push(`${name}: submission deadline is required`)
      else if(end && time(end) < time(start)) errors.push(stepOrder
        ? `${step}: deadline (${formatDate(end)}) cannot be before its opening date (${formatDate(start)})`
        : `${name}: submission deadline (${formatDate(end)}) cannot be before the opening date (${formatDate(start)})`)
    })
  })
  return errors
}
